import {ROLE_NAMES, ROLES_COUNT} from "../constants/Constants";
import agent from "../agent";
import UtilsFunctions from "./UtilsFunctions";

const validateRolesInTeam = (team) => {
    let rolesCounter = 0;
    let allUsersHasRole = true;
    let teamUsers = team.users;
    for (let i = 0; i < teamUsers.length; i++) {
        if (teamUsers[i].role.length === 0) {
            allUsersHasRole = false;
        }
        rolesCounter += teamUsers[i].role.length;
    }
    return rolesCounter === ROLES_COUNT && allUsersHasRole;
}

const usersHasRole = (users, role) => {
    for (let i = 0; i < users.length; i++) {
        let user = users[i];
        if (user.role.includes(role))
            return true;
    }
    return false;
}

const getTeamById = (teams, uuid) => {
    for (let i = 0; i < teams.length; i++) {
        let team = teams[i];
        if (team.uuid === uuid) {
            return team;
        }
    }
    return null;
}

const getCurrentUserRole = (gameId) => {
    let res = [];
    agent.Game.readGame(gameId, response => {
        console.log(response)
        res = response.currentPlayer.role;
    });

    return res;
}

const toPrettyNumber = (num) => {
    //return num.toLocaleString();
    if (Math.abs(num) >= 1000000) {
        return `${Math.floor(num / 1000000)}M`;
    } else {
        return num;
    }
}

const getPlayerRoles = () => {
    return [];
}

const playerHasRole = (role = 0) => {
    return UtilsFunctions.getPlayerRoles().indexOf(role) !== -1;
}

const getRoleNameIndex = (role) => {
    return ROLE_NAMES.indexOf(role);
}

// eslint-disable-next-line import/no-anonymous-default-export
export default {
    validateRolesInTeam,
    getTeamById,
    getCurrentUserRole,
    usersHasRole,
    toPrettyNumber,
    getPlayerRoles,
    playerHasRole,
    getRoleNameIndex
}
